import React from 'react';
import indiaData from '../../data/india_locations.json';

const STATES = (indiaData?.states || []).map(s => s.name);
const inputCls = 'w-full px-3 py-2 border border-slate-300 rounded-sm text-sm focus:border-[#3b4872] focus:outline-none';
const lbl = 'text-[10px] font-display font-bold uppercase tracking-widest text-slate-500 block mb-1';

export const validateSiteFields = (form) => {
  const errs = {};
  const mob = String(form.site_contact_mobile || '').replace(/\D/g, '');
  if (form.site_contact_mobile && !/^[6-9]\d{9}$/.test(mob.length === 12 && mob.startsWith('91') ? mob.slice(2) : mob))
    errs.site_contact_mobile = 'Site contact mobile must be a valid 10-digit mobile number';
  if (form.site_pincode && !/^\d{6}$/.test(String(form.site_pincode).trim()))
    errs.site_pincode = 'Site pincode must be 6 digits';
  return errs;
};

export function SiteDeliveryFields({ form, setForm, errors = {} }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <div className="col-span-2 bg-indigo-50/30 border border-indigo-200 rounded-sm p-3" data-testid="project-site-delivery-group">
      <div className="text-[10px] font-display font-bold uppercase tracking-widest text-[#3b4872] mb-2">Site &amp; delivery</div>
      <p className="text-[11px] text-slate-600 -mt-1 mb-2">Printed as the Shipping Address on POs and MPRs. Site state decides the GST split (CGST+SGST vs IGST).</p>
      <div className="grid grid-cols-2 gap-3">
        <label className="col-span-2 block">
          <span className={lbl}>Site address</span>
          <textarea rows={2} value={form.site_address || ''} onChange={set('site_address')} className={inputCls} data-testid="project-form-site-address" />
        </label>
        <label className="block">
          <span className={lbl}>Site city</span>
          <input value={form.site_city || ''} onChange={set('site_city')} className={inputCls} data-testid="project-form-site-city" />
        </label>
        <label className="block">
          <span className={lbl}>Site state</span>
          <select value={form.site_state || ''} onChange={set('site_state')} className={`${inputCls} bg-white`} data-testid="project-form-site-state">
            <option value="">— Select state —</option>
            {STATES.map(s => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
        <label className="block">
          <span className={lbl}>Site pincode</span>
          <input value={form.site_pincode || ''} onChange={set('site_pincode')} maxLength={6} className={inputCls} data-testid="project-form-site-pincode" />
          {errors.site_pincode && <span className="text-[11px] text-red-600">{errors.site_pincode}</span>}
        </label>
        <label className="block">
          <span className={lbl}>Site contact name</span>
          <input value={form.site_contact_name || ''} onChange={set('site_contact_name')} className={inputCls} data-testid="project-form-site-contact-name" />
        </label>
        <label className="block">
          <span className={lbl}>Site contact mobile</span>
          <input value={form.site_contact_mobile || ''} onChange={set('site_contact_mobile')} inputMode="numeric" maxLength={14} className={inputCls} data-testid="project-form-site-contact-mobile" />
          {errors.site_contact_mobile && <span className="text-[11px] text-red-600" data-testid="project-form-site-mobile-error">{errors.site_contact_mobile}</span>}
        </label>
      </div>
    </div>
  );
}
